import CustomLink from '@/components/custom-link/CustomLink';
import { Urls } from '@/constants/urls';
import envService from '@/services/env.service';
import { Text } from '@cmpsr/components';

export type TroubleshootProps = {
  troubleshootIssue: string;
  linkDisplay: { base: string; md: string } | string;
};

export default function Troubleshoot({ troubleshootIssue, linkDisplay }: TroubleshootProps) {
  return (
    <Text
      variant="text-body-meta-regular"
      w="100%"
      textAlign="center"
      textColor="text-light"
      maxWidth={{ base: '100%', lg: '464px', xl: '529px' }}
      mb={3}
    >
      {troubleshootIssue} See our{' '}
      <CustomLink href={Urls.faqs} variant="link-accent">
        FAQs
      </CustomLink>{' '}
      or{' '}
      <CustomLink display={linkDisplay} href={envService.getEnv().VITE_SUPPORT_APP} variant="link-accent">
        Contact our team
      </CustomLink>
    </Text>
  );
}
